import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import type { InterProvinceDayAheadResponse } from '@/types/api';

export function useInterProvinceDayAhead(date: string, tradeSide: string) {
  return useQuery({
    queryKey: ['interProvince', 'dayAhead', date, tradeSide],
    queryFn: async () => {
      const res = await apiClient.get<InterProvinceDayAheadResponse>(
        '/inter_province/day_ahead',
        { params: { date, trade_side: tradeSide } }
      );
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: !!date && !!tradeSide,
  });
}
